<script>
  // the App component:
  // - is the top entry point for the application
  // - see also main.js

  import { onMount } from "svelte";
  import Header from "./Header.svelte";
  import FooterNoAction from "./FooterNoAction.svelte";
  import {
    extentStore,
    stormStore,
    returnPeriodStore,
    slrYearStore,
    photos360UrlsStore,
    criticalFacilitiesLayersStore,
    criticalFacilitiesStatsStore,
    sideBySideComparisonStore,
    secondarySlrYearStore,
    whichDisplay,
  } from "./stores.js";

  import {
    am_extentStore,
    am_stormStore,
    am_slrYearStore,
    am_returnPeriodStore,
    am_photos360UrlsStore,
    am_sideBySideComparisonStore,
    am_climateReadyBostonLayersStore,
    am_conceptualBWSCProjectsLayersStore,
    am_criticalFacilitiesLayersStore,
    am_criticalFacilitiesStatsStore,
    am_selected_adaptations,
  } from "./stores_adaptation_measures.js";

  import appConfig from "../appConfig.js";
  import Cookies from "js-cookie";
  import EsriMapViewNoAction from "./EsriMapViewNoAction.svelte";
  import EsriMapViewAdaptationMeasures from "./EsriMapViewAdaptationMeasures.svelte";
  import FooterAdaptationMeasures from "./FooterAdaptationMeasures.svelte";

  // export let setWhichDisplay = (name) => {
  //   whichDisplay.set(name);
  // };

  let disclaimerModal;
  onMount(() => {
    // only show the splash screen modal if this is the first time
    // (i.e. there isn't a cookie that was set to being true previously)
    if (!Cookies.get("disableSplashScreenModal")) {
      disclaimerModal.active = true;

      // update the cookie when the modal is closed by any means
      // (the accept button, the X button, or keyboard 'Esc')
      disclaimerModal.beforeClose = function () {
        return new Promise((resolve) => {
          Cookies.set("disableSplashScreenModal", true);
          resolve(); // this will trigger the close animation
        });
      };
    }
  });



  
</script>

<!-- the disclaimer message -->
<calcite-modal
  aria-labelledby="modal-title"
  color="blue"
  bind:this={disclaimerModal}
>
  <h3 slot="header" id="modal-title">Terms &amp; Conditions</h3>

  <div slot="content">
    {appConfig.disclaimerText}
  </div>

  <!--
  <calcite-button
    slot="secondary"
    appearance="outline"
  >
    Cancel
  </calcite-button>
  -->

  <calcite-button
    slot="primary"
    on:click={() => (disclaimerModal.active = false)}
  >
    Accept
  </calcite-button>
</calcite-modal>

<!-- the main business logic of the application -->
<div class="app">
  <Header title={appConfig.headerTitle} />

  <main class="main">
    {#if $whichDisplay === "noaction"}
      <div class="esri-map-view-wrapper">
        <EsriMapViewNoAction
          showMapViewWidgets={true}
          {extentStore}
          {stormStore}
          {returnPeriodStore}
          {slrYearStore}
          {photos360UrlsStore}
          {criticalFacilitiesLayersStore}
          {criticalFacilitiesStatsStore}
          {sideBySideComparisonStore}
        />
      </div>

      {#if $sideBySideComparisonStore}
        <!-- show a dividing line between MapViews -->
        <div style="background-color: #404040; width: 2px;" />

        <div class="esri-map-view-wrapper">
          <EsriMapViewNoAction
            showMapViewWidgets={false}
            {extentStore}
            {stormStore}
            {returnPeriodStore}
            slrYearStore={secondarySlrYearStore}
            {photos360UrlsStore}
            {criticalFacilitiesLayersStore}
            {criticalFacilitiesStatsStore}
            {sideBySideComparisonStore}
          />
        </div>
      {/if}
    {/if}
    {#if $whichDisplay === "adaptationmeasures"}
      <div class="esri-map-view-wrapper">
        <EsriMapViewAdaptationMeasures
          showMapViewWidgets={true}
          {am_extentStore}
          {am_stormStore}
          {am_returnPeriodStore}
          {am_slrYearStore}
          {am_photos360UrlsStore}
          {am_sideBySideComparisonStore}
          {am_climateReadyBostonLayersStore}
          {am_conceptualBWSCProjectsLayersStore}
          {am_criticalFacilitiesLayersStore}
          {am_criticalFacilitiesStatsStore}
           am_whichAdaptation={0}
        />
      </div>

      {#if $am_sideBySideComparisonStore}
        <!-- show a dividing line between MapViews -->
        <div style="background-color: #404040; width: 2px;" />

        <!-- This should be a comparison b/t AdaptationMeasures and No Action-->
        <div class="esri-map-view-wrapper">
          <EsriMapViewAdaptationMeasures
            showMapViewWidgets={false}
            {am_extentStore}
            {am_stormStore}
            {am_returnPeriodStore}
            {am_slrYearStore}
            {am_photos360UrlsStore}
            {am_sideBySideComparisonStore}
            {am_climateReadyBostonLayersStore}
            {am_conceptualBWSCProjectsLayersStore}
            {am_criticalFacilitiesLayersStore}
            {am_criticalFacilitiesStatsStore}
            am_whichAdaptation={1}
          />
        </div>
      {/if}
    {/if}
  </main>

  {#if $whichDisplay === "noaction"}
    <FooterNoAction />
  {/if}
  {#if $whichDisplay === "adaptationmeasures"}
    <FooterAdaptationMeasures />
  {/if}
</div>

<style>
  /*
    styles can go in top-level App.svelte,
    or scoped within each individual .svelte component,
    or in ./public/global.css
  */
</style>
